import type { ReactElement } from "react";
import type { KaizenHealthOutput } from "@playbookai/widget-schemas";
import type { WidgetBodyProps } from "../types.js";

/**
 * The `@2` counts, in reading order: the three live plan states first, then the
 * two warnings, then the two terminal piles. `unassigned` counts COMMITMENTS
 * only, and `notPromoted` is the unactioned pile the capped register cannot show.
 */
const LABELS: ReadonlyArray<readonly [keyof KaizenHealthOutput, string]> = [
  ["onTrack", "On track"],
  ["atRisk", "At risk"],
  ["blocked", "Blocked"],
  ["overdue", "Overdue"],
  ["unassigned", "Unassigned"],
  ["notPromoted", "Not promoted"],
  ["done", "Done"],
];

export function KaizenHealthWidget({
  data,
}: WidgetBodyProps<KaizenHealthOutput>): ReactElement {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between rounded-md bg-pb-card-elevated px-3 py-2">
        <span className="text-sm text-pb-text-secondary">Overall</span>
        <span className="text-sm font-semibold capitalize text-pb-text">
          {data.overall}
        </span>
      </div>
      <dl className="grid grid-cols-2 gap-2">
        {LABELS.map(([key, label]) => (
          <div
            key={key}
            className="rounded-md border border-pb-border px-2 py-2"
          >
            <dt className="text-xs text-pb-text-muted">{label}</dt>
            <dd className="text-lg font-semibold text-pb-text">{data[key]}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
